var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.l_visible
        ? _c(_vm.textboxWhenEmpty ? "v-combobox" : "v-autocomplete", {
            ref: "control",
            tag: "component",
            staticClass: "dynamic-input-control",
            class: {
              validated:
                _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
              required: _vm.l_required,
              naked: _vm.naked,
              readonly: _vm.readonly || _vm.isDisabled || _vm.isLoading
            },
            attrs: {
              "data-id": _vm.dataId,
              dense: _vm.dense,
              outlined: _vm.outlined,
              multiple: _vm.multiple,
              placeholder: _vm.placeholder,
              "menu-props": _vm.menuProps,
              items: _vm.data,
              "hide-no-data": _vm.searchFunction != null,
              "search-input": _vm.search,
              value: _vm.currentValue,
              "item-text": _vm.l_displayMember,
              "item-value": _vm.l_valueMember,
              loading: _vm.isLoading || _vm.searchLoading,
              rules: _vm.getRules,
              filter: _vm.customFilter,
              "return-object": _vm.returnObject,
              "append-icon": _vm.getDisabled ? "" : "mdi-chevron-down",
              "error-messages": _vm.errorMessages,
              clearable: _vm.clearable,
              disabled: _vm.getDisabled,
              readonly: _vm.readonly
            },
            on: {
              "update:searchInput": function($event) {
                _vm.search = $event
              },
              "update:search-input": function($event) {
                _vm.search = $event
              },
              focusout: _vm.lostFocus,
              change: _vm.onChange
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _vm._v(" " + _vm._s(_vm.getLabel) + " "),
                      _vm.optional
                        ? _c("span", { staticClass: "optional" }, [
                            _vm._v("(nepovinné)")
                          ])
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "append",
                  fn: function() {
                    return [
                      !!_vm.getTooltip && !_vm.hideTooltip
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "350" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "btn-help text-body-2 ml-2",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-help-circle")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1426974712
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.getTooltip) + " ")
                              ])
                            ]
                          )
                        : _vm._e(),
                      !_vm.getDisabled
                        ? _c(
                            "div",
                            {
                              staticClass: "v-input__icon v-input__icon--append"
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                            1
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              647027808
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }